document.addEventListener('DOMContentLoaded',function(){
  const menu=document.querySelector('.menu-button'),nav=document.querySelector('.site-nav');
  if(menu&&nav){menu.addEventListener('click',()=>{const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',String(open));});}
  document.querySelectorAll('[data-sc-protected],.product-card-image img,.collection-tile img,.hero-bg img,.story-image img,.room-art img,.product-main-image img').forEach(img=>img.addEventListener('dragstart',e=>e.preventDefault()));
  document.addEventListener('contextmenu',function(e){if(e.target.closest('[data-sc-protected],.product-card-image,.collection-tile,.hero-bg,.story-image,.room-art,.product-main-image'))e.preventDefault();});
  document.querySelectorAll('[data-sc-clean-title]').forEach(el=>{const t=el.textContent.trim();const m=t.match(/^([A-Za-z0-9!]+-[A-Za-z0-9]+)\s+(.+)$/);if(m)el.textContent=m[2];});
  const root=document.querySelector('[data-sc-product]');
  if(root){
    const dataEl=root.querySelector('[data-sc-variants]');
    if(dataEl){
      const variants=JSON.parse(dataEl.textContent||'[]');
      const finishBtns=[...root.querySelectorAll('[data-sc-finish]')];
      const sizeBtns=[...root.querySelectorAll('[data-sc-size]')];
      const select=root.querySelector('select[name="id"]');
      const price=root.querySelector('[data-live-price]');
      const summary=root.querySelector('[data-selection-summary]');
      let finish=root.dataset.initialFinish||finishBtns.find(b=>b.classList.contains('active'))?.dataset.scFinish||'';
      let size=root.dataset.initialSize||sizeBtns.find(b=>b.classList.contains('active'))?.dataset.scSize||'';
      const findVariant=()=>variants.find(v=>v.option1===finish&&v.option2===size);
      const refresh=()=>{
        sizeBtns.forEach(b=>{const possible=variants.some(v=>v.option1===finish&&v.option2===b.dataset.scSize&&v.available);b.disabled=!possible;});
        let v=findVariant();
        if(!v||!v.available){const first=variants.find(x=>x.option1===finish&&x.available);if(first){size=first.option2;v=first;}}
        finishBtns.forEach(b=>b.classList.toggle('active',b.dataset.scFinish===finish));
        sizeBtns.forEach(b=>b.classList.toggle('active',b.dataset.scSize===size));
        if(v&&select){select.value=String(v.id);if(price)price.textContent=v.money;if(summary)summary.textContent=`${finish} · ${size}`;}
      };
      finishBtns.forEach(b=>b.addEventListener('click',()=>{finish=b.dataset.scFinish;refresh();}));
      sizeBtns.forEach(b=>b.addEventListener('click',()=>{if(!b.disabled){size=b.dataset.scSize;refresh();}}));
      refresh();
    }
  }
});
